import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const HeartSearchIcon: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 34 34"
    fill="none"
    {...props}
  >
    <path
      d="M34 17C34 7.611 26.389 0 17 0C7.611 0 0 7.611 0 17C0 26.389 7.611 34 17 34C26.389 34 34 26.389 34 17Z"
      fill="white"
    />
    <path
      d="M28.7091 17.255L17.0001 28.963L6.87807 18.841L5.29106 17.255C3.89606 15.852 3.19507 14.025 3.19507 12.197C3.19507 10.37 3.89606 8.52798 5.29106 7.13298C8.08206 4.33498 12.6161 4.33498 15.4061 7.13298L17.0001 8.72599L18.5941 7.13298C21.3851 4.33498 25.9181 4.33498 28.7091 7.13298C31.5071 9.93098 31.5071 14.457 28.7091 17.255Z"
      fill="#FF612B"
    />
    <path
      d="M24.792 10.022H20.882C20.492 10.022 20.173 10.341 20.173 10.731C20.173 11.12 20.492 11.439 20.882 11.439H23.106L20.308 14.237C19.394 13.529 18.247 13.111 17.007 13.111C14.011 13.111 11.574 15.547 11.574 18.544C11.574 21.54 14.011 23.977 17.007 23.977C20.003 23.977 22.44 21.54 22.44 18.544C22.44 17.304 22.015 16.157 21.314 15.243L24.09 12.466V14.648C24.09 15.037 24.409 15.356 24.799 15.356C25.188 15.356 25.507 15.037 25.507 14.648V10.738C25.507 10.348 25.188 10.03 24.799 10.03L24.792 10.022ZM17 22.56C14.783 22.56 12.984 20.761 12.984 18.544C12.984 16.327 14.783 14.527 17 14.527C19.217 14.527 21.016 16.327 21.016 18.544C21.016 20.761 19.217 22.56 17 22.56Z"
      fill="#3D3C38"
    />
  </Box>
)

export default HeartSearchIcon
